export default {
  isDisabledAddToCart: false,
};
